<template>
  <div class="portal-page">
    <div v-if="title" class="page-hero">
      <div class="hero-content">
        <div v-if="iconClass" class="hero-icon-chip icon-chip" aria-hidden="true">
          <span class="mdi" :class="iconClass" />
        </div>
        <div class="hero-text">
          <h1 class="hero-title">{{ title }}</h1>
          <p v-if="subtitle" class="hero-subtitle">{{ subtitle }}</p>
        </div>
      </div>
    </div>
    <div class="portal-page-body">
      <slot />
    </div>
  </div>
</template>

<script>
import { getNavIconForRoute } from '../../js/navConfig';

export default {
  name: 'PortalPageShell',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    /** Optional override; otherwise uses the left-nav icon for the current route */
    icon: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconClass() {
      const raw = this.icon || getNavIconForRoute(this.$route && this.$route.name);
      if (!raw) return '';
      return raw.startsWith('mdi-') ? raw : `mdi-${raw}`;
    },
  },
};
</script>
